import { SIGNUP_TEXT } from "../../domain/constants/constants";
import { styles as s } from "../../styles/signupstyles";

type Props = {
  method: "email" | "phone";
};

export default function TermsSection({
  method,
}: Props) {
  return (
    <p className={s.terms}>
      {SIGNUP_TEXT.termsPrefix}{" "}

      <a
        href="/terms"
        className={s.termsLink}
      >
        {SIGNUP_TEXT.terms}
      </a>{" "}

      {SIGNUP_TEXT.and}{" "}

      <a
        href="/privacy"
        className={s.termsLink}
      >
        {SIGNUP_TEXT.privacy}
      </a>

      {method === "phone" && (
        <>
          {" "}
          {SIGNUP_TEXT.smsConsent}
        </>
      )}
    </p>
  );
}